/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { Document } from '../../core/models/Document';
import { OasDocument } from '../../openapi/models/OasDocument';
import { OasPathItem } from '../../openapi/models/OasPathItem';
import { ReplaceNodeCommand } from './ReplaceNodeCommand';

/**
 * A command used to replace a path item with a newer version.
 * @author eric.wittmann@gmail.com
 * @extends ReplaceNodeCommand
 * @class
 */
export class ReplacePathItemCommand extends ReplaceNodeCommand<OasPathItem> {
    public _pathName : string;

    public constructor(old? : any, replacement? : any) {
        if(((old != null && old instanceof <any>OasPathItem) || old === null) && ((replacement != null && replacement instanceof <any>OasPathItem) || replacement === null)) {
            let __args = arguments;
            super(old, replacement);
            if(this._pathName===undefined) this._pathName = null;
            if(this._pathName===undefined) this._pathName = null;
            (() => {
                this._pathName = replacement.getPath();
            })();
        } else if(old === undefined && replacement === undefined) {
            let __args = arguments;
            super();
            if(this._pathName===undefined) this._pathName = null;
            if(this._pathName===undefined) this._pathName = null;
        } else throw new Error('invalid overload');
    }

    public removeNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_openapi_models_OasPathItem(doc : Document, node : OasPathItem) {
        let odoc : OasDocument = <OasDocument>doc;
        odoc.paths.removePathItem(node.getPath());
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.ReplaceNodeCommand#removeNode(io.apicurio.datamodels.core.models.Document, io.apicurio.datamodels.core.models.Node)
     * @param {Document} doc
     * @param {OasPathItem} node
     */
    public removeNode(doc? : any, node? : any) : any {
        if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null && node instanceof <any>OasPathItem) || node === null)) {
            return <any>this.removeNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_openapi_models_OasPathItem(doc, node);
        } else if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null) || node === null)) {
             throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)'); 
        } else throw new Error('invalid overload');
    }

    public addNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_openapi_models_OasPathItem(doc : Document, node : OasPathItem) {
        let odoc : OasDocument = <OasDocument>doc;
        node._ownerDocument = odoc;
        node._parent = odoc.paths;
        odoc.paths.addPathItem(this._pathName, node);
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.ReplaceNodeCommand#addNode(io.apicurio.datamodels.core.models.Document, io.apicurio.datamodels.core.models.Node)
     * @param {Document} doc
     * @param {OasPathItem} node
     */
    public addNode(doc? : any, node? : any) : any {
        if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null && node instanceof <any>OasPathItem) || node === null)) {
            return <any>this.addNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_openapi_models_OasPathItem(doc, node);
        } else if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null) || node === null)) {
             throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)'); 
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.ReplaceNodeCommand#readNode(io.apicurio.datamodels.core.models.Document, java.lang.Object)
     * @param {Document} doc
     * @param {*} node
     * @return {OasPathItem}
     */
    readNode(doc : Document, node : any) : OasPathItem {
        let odoc : OasDocument = <OasDocument>doc;
        let pathItem : OasPathItem = odoc.paths.createPathItem(this._pathName);
        Library.readNode(node, pathItem);
        return pathItem;
    }
}
ReplacePathItemCommand["__class"] = "io.apicurio.datamodels.cmd.commands.ReplacePathItemCommand";
ReplacePathItemCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




